export default __webpack_public_path__ + "static/media/trash-icon.259353d6.svg";